export const IMAGE_BUCKET = 'site-images';

/** 이 년월(YYYYMM)부터 Storage 월별 폴더 사용 */
export const MONTHLY_STORAGE_FROM_YM = '202606';

export const usesMonthlyStorageFolder = (yearMonth) =>
  Boolean(yearMonth && yearMonth.length === 6 && yearMonth >= MONTHLY_STORAGE_FROM_YM);

const YEAR_MONTH_SUFFIX_RE = /_(\d{6})$/;

export const getStorageFileName = (storagePath) => {
  if (!storagePath) return '';
  const normalized = String(storagePath).replace(/^\/+/, '');
  const parts = normalized.split('/');
  return parts[parts.length - 1] || normalized;
};

/** 파일명에서 기존 _YYYYMM 접미사를 제거한 순수 파일명 */
export const getBaseFileName = (fileName) => {
  if (!fileName) return '';
  const trimmed = String(fileName).trim();
  const dot = trimmed.lastIndexOf('.');
  const namePart = dot > 0 ? trimmed.slice(0, dot) : trimmed;
  const ext = dot > 0 ? trimmed.slice(dot) : '';
  const baseName = namePart.replace(YEAR_MONTH_SUFFIX_RE, '');
  return `${baseName}${ext}`;
};

/** 파일명에 _YYYYMM 접미사 추가 (이미 있으면 해당 년월로 교체) */
export const appendYearMonthToFileName = (fileName, yearMonth) => {
  if (!fileName || !yearMonth || yearMonth.length !== 6) return fileName || '';
  const base = getBaseFileName(fileName);
  const dot = base.lastIndexOf('.');
  if (dot > 0) {
    return `${base.slice(0, dot)}_${yearMonth}${base.slice(dot)}`;
  }
  return `${base}_${yearMonth}`;
};

/**
 * Storage 저장 경로 결정
 * - 입력 경로의 폴더·_YYYYMM 접미사는 무시
 * - 목록 year_month 기준: {기존파일명}_{YYYYMM}.ext
 * - 202606+ : `{year_month}/{파일명}_{year_month}.ext`
 */
export const resolveMonthlyStoragePath = (storagePath, yearMonth) => {
  const trimmed = storagePath?.trim() || '';
  if (!trimmed || !yearMonth || yearMonth.length !== 6) {
    return trimmed;
  }

  const rawFileName = getStorageFileName(trimmed);
  const suffixedFileName = appendYearMonthToFileName(rawFileName, yearMonth);

  if (usesMonthlyStorageFolder(yearMonth)) {
    return `${yearMonth}/${suffixedFileName}`;
  }

  return suffixedFileName;
};

export const copyStorageObject = async (supabase, fromPath, toPath) => {
  if (!fromPath || !toPath || fromPath === toPath) return;
  const { error } = await supabase.storage.from(IMAGE_BUCKET).copy(fromPath, toPath);
  if (error) throw error;
};
